import 'core-js/modules/es.object.assign.js';
import { elevationTokens } from './elevation-tokens.js';

var Elevations = Object.assign({}, elevationTokens);

export { Elevations };
